function GeoLocationCheck (to, from) {
  if (!this.state.geolocation.countryCode) {
    this.dispatch('geolocation/loadCountryCode')
  }
}
export default GeoLocationCheck



// WEBPACK FOOTER //
// ./src/modules/geolocation/middleware/GeoLocationCheck.js